/* eslint-disable @typescript-eslint/camelcase */
import * as Yup from 'yup';
import i18n from 'i18n';

export default Yup.object().shape({
  action_reason: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .max(
      280,
      i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
        max_length: 280,
      })
    ),
});
